import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, BookOpenIcon, MessageCircleIcon, ShieldIcon, HeartIcon, SparklesIcon } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function MethodCACSection() {
  return <section className="bg-teal-dark py-24 px-6 text-white overflow-hidden relative" data-id="element-126">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-127">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-128"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-teal rounded-full blur-3xl" data-id="element-129"></div>
      </div>

      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeIn} className="max-w-4xl mx-auto text-center relative z-10" data-id="element-130">
        <h2 className="text-teal-100 text-sm md:text-base font-sans tracking-widest uppercase mb-4" data-id="element-131">
          Presentando: El Método C.A.C.
        </h2>
        <h3 className="text-4xl md:text-5xl font-bold mb-8 font-serif" data-id="element-132">
          Conexión Antes que Corrección
        </h3>

        <div className="text-lg md:text-xl text-teal-50 leading-relaxed space-y-6 font-light text-left md:text-center" data-id="element-133">
          <p data-id="element-134">
            Este no es un libro de teoría de 400 páginas. Es un kit de auxilio
            rápido diseñado para la "vida real".
          </p>
          <p data-id="element-135">
            El método C.A.C. se basa en la neurociencia aplicada: primero
            bajamos las revoluciones del sistema nervioso (Conexión) para que,
            una vez que el cerebro lógico se encienda, el niño pueda entender el
            límite (Corrección).
          </p>
          <p className="font-medium text-white text-xl md:text-2xl mt-8" data-id="element-136">
            Tú te conviertes en el ancla que detiene la tormenta en lugar de ser
            parte de ella.
          </p>
        </div>
      </motion.div>
    </section>;
}
export function WhatYouGetSection() {
  const deliverables = [{
    title: 'Guía Digital "Berrinches en Calma"',
    desc: 'El manual paso a paso con la ciencia y la práctica.',
    icon: BookOpenIcon
  }, {
    title: 'El Protocolo de las 3 Frases Mágicas',
    desc: 'Qué decir exactamente para desactivar el llanto en segundos.',
    icon: MessageCircleIcon
  }, {
    title: 'Manual de Supervivencia en Público',
    desc: 'Cómo manejar la presión social en el mall o restaurantes sin perder los papeles.',
    icon: ShieldIcon
  }, {
    title: 'Kit de Reconstrucción',
    desc: 'Qué hacer después del berrinche para fortalecer el lazo con tu hijo.',
    icon: HeartIcon
  }, {
    title: 'Hoja de Ruta del Perdonarse',
    desc: 'Cómo sacudirse la culpa después de un día difícil.',
    icon: SparklesIcon
  }];
  const container = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="bg-cream-dark py-24 px-6" data-id="element-137">
      <div className="max-w-5xl mx-auto" data-id="element-138">
        <motion.h2 initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-139">
          Lo que recibirás
        </motion.h2>

        <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-140">
          {deliverables.map((del, index) => <motion.div key={index} variants={item} className="bg-white p-8 rounded-2xl shadow-soft flex flex-col items-start" data-id="element-141">
              <div className="w-12 h-12 bg-cream rounded-full flex items-center justify-center mb-6" data-id="element-142">
                <del.icon className="w-6 h-6 text-teal-dark" data-id="element-143" />
              </div>
              <h4 className="text-xl font-bold mb-3" data-id="element-144">{del.title}</h4>
              <p className="text-brown leading-relaxed" data-id="element-145">{del.desc}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}